import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import {GreatTable} from 'components/common';

const useStyles = makeStyles(() => ({
  tableCell: {
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  titleTableCell: {
    whiteSpace: 'nowrap',
    textAlign: 'left',
    marginLeft: 20,
  },
  optionTableCell: {
    whiteSpace: 'nowrap',
    textAlign: 'left',
    marginLeft: 20,
  },
  dot: {
    height: 5,
    width: 5,
    marginRight: 10,
    borderRadius: '50%',
    backgroundColor: '#bbb',
    display: 'inline-block',
  },
}));

const ClassroomAdminReadingNightsTable = (props) => {
  const classes = useStyles();
  return (
    <GreatTable
      {...props}
      itemName="reading nights"
      getFieldsMapping={(reader) => ({
        name: `${reader.firstName} ${reader.lastName}`,
        username: reader.username,
        baseReadingDates: reader.baseReadingDates,
        readingDates: reader.readingDates,
        totalReadingDates: reader.baseReadingDates + reader.readingDates,
      })}
      getFieldsSettings={() => ({
        name: {
          fieldText: 'Name',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
        },
        username: {
          fieldText: 'Username',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
        },
        baseReadingDates: {
          fieldText: 'Base Reading Nights',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
        },
        readingDates: {
          fieldText: 'Reading Dates',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
        },
        totalReadingDates: {
          fieldText: 'Total Reading Dates',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
        },
      })}
    />
  );
};

export default ClassroomAdminReadingNightsTable;
